export default `<div>
    <div class="alert-container">
        <div class="alert-icon-container"></div>
        <div class="alert-content-slot">
            <slot></slot>
        </div>
    </div>
</div>
<style>
    :host {
        font-family: var (--svea-default-font, "'Asap', Arial, sans-serif");
    }

    * {
        font-family: var (--svea-default-font, "'Asap', Arial, sans-serif");
    }

    .alert-container {
        background-color: var(--svea-alert-bg-information, #e8f6f9);
        border-left: var(--svea-alert-left-border-padding, 0.313rem) solid
            var(--svea-alert-border-information, #00325c);
        border-radius: 0.5rem;
        padding: var(--svea-alert-padding, 1.25rem 0.75rem 1.25rem 1rem);
        color: var(--svea-alert-text, #434343);
        display: grid;
        grid-template-columns: auto 1fr auto;
        grid-template-rows: auto;
    }

    .alert-container.error {
        background-color: var(--svea-alert-bg-error, #ffe9e9);
        border-left: var(--svea-alert-left-border-padding, 0.313rem) solid
            var(--svea-alert-border-error, #c73535);
    }

    .alert-container.warning {
        background-color: var(--svea-alert-bg-warning, #fff2e2);
        border-left: var(--svea-alert-left-border-padding, 0.313rem) solid
            var(--svea-alert-border-warning, #d17300);
    }

    .alert-container.success {
        background-color: var(--svea-alert-bg-success, #dbf2c6);
        border-left: var(--svea-alert-left-border-padding, 0.313rem) solid
            var(--svea-alert-border-success, #406d0d);
    }

    .alert-container.pending {
        background-color: var(--svea-alert-bg-pending, #f1f0eb);
        border-left: var(--svea-alert-left-border-padding, 0.313rem) solid
            var(--svea-alert-border-pending, #434343);
    }

    @media (max-width: 768px) {
        .alert-container {
            padding: var(--svea-alert-padding-mobile, 1rem);
        }
    }

    .alert-content-container {
        display: flex;
    }

    .alert-icon-container {
        margin-right: 0.75rem;
        width: 1.5rem;
        height: 1.5rem;
        grid-column: 1;
    }

    @media (max-width: 768px) {
        .alert-icon-container {
            margin-top: 0.125rem;
        }
    }

    .alert-icon-container img {
        width: 1.5rem;
    }

    .alert-content-slot {
        grid-column: 2;
    }

    .close-button-container {
        position: relative;
    }

    .close-button {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: -0.75rem;
        left: -1.5rem;
        height: 1.5rem;
        width: 1.5rem;
        background: none;
        border: none;
        cursor: pointer;
        grid-column: 3;
    }

    .close-button:focus,
    .close-button:focus-visible {
        outline: 0.125rem solid var(--svea-interactive-primary-active, #115475);
        border-radius: 0.5rem;
        outline-offset: 0.125rem;
    }

    .close-button img {
        width: 0.85rem;
    }

    @media (max-width: 768px) {
        .close-button {
            top: -0.25rem;
            left: -1.25rem;
        }
    }
</style>
`